import { axiosInstance } from "../../../axios/axiosInstance";

const API_CHAT_CONVERSATION_URL = "admin/chat-conversation";
const API_CHAT_CONVERSATION_USER_MODULE_LIST_URL = API_CHAT_CONVERSATION_URL + "/list";
const API_CHAT_CONVERSATION_BY_ID_URL = API_CHAT_CONVERSATION_URL + "/view";

export const getChatConversation = (dataToBeSent) => {
  return axiosInstance.get(`${API_CHAT_CONVERSATION_USER_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}&filters[roles]=${dataToBeSent?.filters ?? ''}`);
};

export const getChatConversationById = (dataToBeSent) => {
  return axiosInstance.get(`${API_CHAT_CONVERSATION_BY_ID_URL}/${dataToBeSent?.selectedChatConversationId}`);
};